import countryData from 'country-data';

export default function GetCountryName(countryCode: any) {
  
  const countryName = countryData.countries[countryCode].name;

  return countryName;

}
